export default __webpack_public_path__ + "static/media/IMG_48963.d470a8aa.jpg";